import { defineNuxtPlugin } from '#app/nuxt';
import { blockContextIsContentPage, blockEditorHooks } from '#layers/block-engine/public';

export default defineNuxtPlugin((_nuxtApp) => {
	// Hide input blocks when they are at the root of a content page (detail/listing pages)
	blockEditorHooks.isBlockHiddenInLibrary.push(({ block, isRoot, ...context }) => {
		if (block.type === 'input' && isRoot && blockContextIsContentPage(context)) {
			return true;
		}
	});
});
